import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import logo from '../../Web Mundo/logo.png'
import Button from '@mui/material/Button';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Alert, Avatar, CardMedia, Modal, Snackbar, Stack, TextField } from '@mui/material';
import EvStationIcon from '@mui/icons-material/EvStation';
import { useDispatch, useSelector } from 'react-redux';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Link, useNavigate } from 'react-router-dom';
import { useFetch } from '../../hook/useFetch';
import { rutas } from '../../rutas/rutas';
import { exit, setInformacion } from '../../storage/slices/usuarios';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getCookie } from '../../utils/getCookie';
import axios from 'axios';
import hueso from '../../Web Mundo/hueso.png'
import discord from '../../Web Mundo/discord.png'
import BookIcon from '@mui/icons-material/Book';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 620,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  color: 'white'
};
const NavBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorText, setErrorText] = React.useState("Error");
  const [password, setPassword] = React.useState('');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClose2 = () => setOpen2(false);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [peticion] = useFetch()
  const [deposit, setDeposit] = React.useState(0);
  const {informacion} = useSelector(state=> state.userSlice)
  const cerrarSesion= ()=>{
    dispatch(exit({}))
    sessionStorage.setItem('user', JSON.stringify({logged: false}))
    navigate('/login', {
      replace:true
    })
   }
  const handleChange = (e) => setPassword(e.target.value)
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const transfer = (cantidad,setOpen3, memo= "Deposit",token)=>{
    const json = {
        "contractName": "tokens",
        "contractAction": "transfer",
        "contractPayload": {
            "symbol":token,
            "to": "mv-token1",
            "quantity": cantidad.toString(),
            "memo": memo

        }
    }

const username = JSON.parse(sessionStorage.getItem('user'))
    window.hive_keychain.requestCustomJson(username.user, "ssc-mainnet-hive", "Active", JSON.stringify(json), 'Transfer', function (response) {
        if (response.success && response.result) {
            const tokenJWT = getCookie('token')
       
            axios.post(rutas.deposit,{id: response?.result?.id}, { headers: {'token': tokenJWT}}).then(response=>{
                if(response.status === 200 ) setOpen3(true)
          
            })
           
      
        } else {
            console.log(response)
            //show modal
        }
    });
}
  const handleTransfer = (token="HUESO")=>{

    
    transfer(deposit,  setOpen2(true),"Deposit", token)
  }
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const retiroInterno =  async () =>{
    try {
      const tokenJWT = getCookie('token')
      const resultado = await axios({
      method: 'get',
      url: rutas.retiroInterno,
      headers:  {
        'token': tokenJWT,
        'Content-Type': 'application/json'},
    
      
  })
   
   if(resultado?.data) {
    dispatch(setInformacion(resultado?.data?.usuario));
    setError(false)
    setOpen2(true)
    setErrorText("")
   }else{
    setError(true)
    setOpen2(true)
  
   }
    } catch (error) {
      setErrorText(error?.response?.data?.error)
      setError(true)
      setOpen2(true)
    }

   
   }
  const retiroDinero =  async () =>{
    try {
      const tokenJWT = getCookie('token')
      const resultado = await axios({
      method: 'get',
      url: rutas.retiro,
      headers:  {
        'token': tokenJWT,
        'Content-Type': 'application/json'},
    
      
  })
   
   if(resultado?.data) {
    dispatch(setInformacion(resultado?.data?.usuario));
    setError(false)
    setOpen2(true)
   }else{
    setError(true)
    setOpen2(true)
   }
    } catch (error) {
      setErrorText(error?.response?.data?.error)

      setError(true)
      setOpen2(true)
    }

   
   }
const changePassword = async()=>{
 if(password === '' ||  password?.length < 4 && password?.length > 12){
  setError(true)
  setOpen2(true)
 }else{
  const tokenJWT = getCookie('token')
  const resultado = await axios({
  method: 'post',
  url: rutas.changePass,
  headers:  {
    'token': tokenJWT,
    'Content-Type': 'application/json'},
  data: {password}
  
})

if(resultado?.data) {

setError(false)
setOpen2(true)
}


 }
}
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
        <Box sx={{ flexGrow: 1, display: { xs: 'flex' } , justifyContent: 'space-between'}}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{display: { xs: 'block', md: 'none' },}}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
      
                <MenuItem onClick={handleCloseNavMenu}>
                <Link style={{color: 'white', textDecoration: 'none'}} to="/game/">INICIO</Link>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                <Link style={{color: 'white', textDecoration: 'none'}} to="/game/album">ALBUM</Link>

                </MenuItem>
          
                 <MenuItem onClick={handleCloseNavMenu}>
                 <Link style={{color: 'white', textDecoration: 'none', textTransform: 'uppercase'}} to="/game/market">in-game market</Link>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                <Link style={{color: 'white', textDecoration: 'none'}} to="/game/inventory">INVENTORY</Link>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                <Link style={{color: 'white', textDecoration: 'none'}} to="/game/stake">STAKE</Link>
                </MenuItem>
            </Menu>
          </Box>
        <CardMedia
              component="img"
              image={logo}
              alt="avatar"
              sx={{width: '90px', display: {xs: 'none', md: 'block'}}} />
        <Box sx={{ width: {xs: '100%', sm: '72%'}, display: {xs: 'none', md:'flex'}, justifyContent: 'space-evenly'}}>
        <Button to="/game/" component={Link} sx={{width: '150px'}} variant="contained">
            <Link style={{color: 'white', textDecoration: 'none'}} to="/game/">INICIO</Link>
            </Button>
            <Button to="/game/market/" component={Link} sx={{width: '170px'}} variant="contained">

            <Link  style={{color: 'white', textDecoration: 'none', textTransform: 'uppercase'}} to="/game/market">in-game market</Link>
            </Button>
            
            <Button to="/game/album" component={Link} sx={{width: '150px'}}  variant="contained">
            <Link style={{color: 'white', textDecoration: 'none'}} to="/game/album">ALBUM</Link>

            </Button>
               <Button to="/game/inventory" component={Link} sx={{width: '150px'}} variant="contained">

            <Link style={{color: 'white', textDecoration: 'none'}} to="/game/inventory">INVENTORY</Link>
            </Button>
            <Link style={{color: 'white', textDecoration: 'none'}} to="/game/stake">
            <Button sx={{width: '150px'}}  variant="contained">
         STAKE          </Button>
         </Link>  
        </Box>
        
         <Box sx={{width: {xs: '85%', md: '25%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}}>
          <Typography sx={{color: 'gold'}}>
            {informacion?.dinero} 
          </Typography>
          <CardMedia
        component="img"
              sx={{width: '20px', mr:1}}
        image={hueso}
        alt="Paella dish"
      />

          <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <Typography>
              {informacion?.energia?.actual} /
            </Typography>
            <Typography>
            {informacion?.energia?.maximo}
            </Typography>
            <EvStationIcon sx={{fontSize: '35px'}} />
         <AccountCircleIcon onClick={handleOpen} sx={{fontSize: '35px', cursor: 'pointer'}} />
         <ExitToAppIcon onClick={cerrarSesion} sx={{  fontSize: '35px',"&:hover": {cursor: 'pointer'}}}  />
         <a href="https://mundo-virtual.gitbook.io/whitepaper/" target="_blank">
         <BookIcon sx={{  fontSize: '35px',"&:hover": {cursor: 'pointer',  fontStyle: 'none'}}}/>
         </a>
         <a href="https://discord.gg/GJS6MtKB2x" target="_blank">
                  <CardMedia
              component="img"
              image={discord}
              alt="avatar"
         
              sx={{width: {xs: '1.rem', md: '1.7rem'},height: {xs: '1.5rem', md: '1.7rem', "&:hover": { cursor: 'pointer'} }}} />
                  </a>
          </Box>
       
         </Box>
        </Toolbar>
      </Container>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{color: 'white', textAlign: 'center'}} id="modal-modal-title" variant="h6" component="h2">
          Profile
          </Typography>
          <Typography>
             Name: {informacion?.nombre} 
            </Typography>
            <Typography>
            Level: {informacion?.nivel} 
            </Typography>
            <Typography>
            Power Hueso: {informacion?.ph} 
            </Typography>
            <Typography>
            Power energy: {informacion?.pe} 
            </Typography>
            <Typography>
            HUESO in game:  {informacion?.dinero} 
            </Typography>
            <Typography>
            HUESO :  {informacion?.dineroReal} 
            </Typography>
            <Typography>
            VIPHUESO:  {informacion?.fusion} 
            </Typography>
            <Typography sx={{color: 'green'}}>
            BONUS: {informacion?.nivel * 0.25}%
            </Typography>
            <Typography>
            MISSIONS DONE :  {informacion?.cantidadMision} 
            </Typography>
            <Typography>
            Percentage:  {informacion?.porcentaje}% 
            </Typography>
            <Typography>
            Unique NFT types (not duplicates):  {informacion?.nftUnicos} 
            </Typography>
        <TextField onChange={handleChange} type="password" fullWidth id="standard-basic" label="Change Password" variant="standard" />
        <Button disabled={!informacion?.packInicial} sx={{m:1}} onClick={retiroInterno} variant="contained">{informacion?.packInicial ?  'Withdraw in game' : 'Buy Initial pack'} </Button>
       <Button sx={{m:1}} onClick={changePassword} variant="contained">Change Password</Button>
        <Box>
        <TextField value={deposit} onChange={(e)=>setDeposit(e.target.value)} type="number" fullWidth sx={{ color: 'white'}} label="Deposit" variant="outlined" />
        <Button onClick={()=>handleTransfer("HUESO")} variant="contained" sx={{m: 1}}>
          Deposit
            </Button>
               <Button onClick={()=>handleTransfer("VIPHUESO")} variant="contained" sx={{m: 1}}>
          Deposit VIPHUESO
            </Button>
            <Button sx={{m:1}} onClick={retiroDinero} variant="contained">Withdraw All</Button>
        </Box>
        <Typography>Referral link: https://www.bigdogbonegame.com/login/{informacion?.nombre}</Typography>
        </Box>
      </Modal>
      <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
        {
           error ?   <Alert
              onClose={handleClose2}
              severity="error"
              variant="filled" 
              sx={{ width: "100%" }}
            >
             {errorText}
            </Alert>
            :
            <Alert
              onClose={handleClose2}
              severity="success"
              variant="filled" 
              sx={{ width: "100%" }}
            >
              Success
            </Alert>
        }
          </Snackbar>
        </Stack>
    </AppBar>
  );
};
export default NavBar;
